// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

import { t } from "../lib/messages";

/**
 * The app's entries in the Shopify admin navigation. App Bridge reads this element and draws
 * the menu outside the iframe; it renders nothing inside the app.
 */
export function AppNav() {
  return (
    <s-app-nav>
      {/* rel="home" marks the landing page for App Bridge; Polaris' s-link types don't list it. */}
      <s-link href="/" {...{ rel: "home" }}>
        {t("nav.home")}
      </s-link>
      <s-link href="/catalog">{t("nav.catalog")}</s-link>
      <s-link href="/subscriptions">{t("nav.subscriptions")}</s-link>
      <s-link href="/granite">{t("nav.granite")}</s-link>
      <s-link href="/usage">{t("nav.usage")}</s-link>
      <s-link href="/activity">{t("nav.activity")}</s-link>
      <s-link href="/help">{t("nav.help")}</s-link>
    </s-app-nav>
  );
}
